import * as React from 'react'
import { ConfirmationModal, Box, Typography, Loader } from 'cs-kevlar-react'
import { CustomerInterface } from 'contexts/CurrentCustomerContext'
import { useCurrentCustomer } from 'hooks'

interface DownloadCertificateModalProps {
  customerAgencyId: string
  customerInterface: CustomerInterface | null
  onClose: () => void
  open: boolean
}

export const DownloadCertificateModal: React.FunctionComponent<DownloadCertificateModalProps> = ({
  customerAgencyId,
  customerInterface,
  onClose,
  open,
}) => {
  if (customerInterface === null) return null

  const { dispatch } = useCurrentCustomer(customerAgencyId)

  const confirmCertDownload = () => {
    const download = document.createElement('a')
    download.href = `api/customerAgencies/${customerAgencyId}/customerInterfaces/${customerInterface.id}/certificate`
    download.target = '_blank'
    download.click()

    const newConnector: CustomerInterface = {
      ...customerInterface,
      downloadedOn: new Date().toUTCString(),
    }

    dispatch({
      type: 'EditConnector',
      payload: newConnector,
    })

    onClose()
  }
  return (
    <ConfirmationModal
      onConfirm={confirmCertDownload}
      onClose={onClose}
      onCancel={onClose}
      open={open}
      showCancelButton={false}
      confirmText="Download"
      confirmButtonColor="primary"
      title="Certificate Download"
      message={
        <Typography variant="body1">
          Connector certificates are only available for download one time. Once
          you download the certificate, store it in a secure and safe place
          where it cannot be lost or compromised since you will not be able to
          download it again.
        </Typography>
      }
    />
  )
}
